import React, {
  useCallback, useEffect, useState, useRef,
} from 'react'
import Form, { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormField from '@active/react-ui/FormField'
import RadioGroup from '@active/react-ui/RadioGroup'
import Locale from '@active/react-utils/i18n/Locale'
import ConfirmModal from '@active/react-ui/ConfirmModal'
import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find'
import ShippingListItem from './ShippingListItem'
import {
  isDefaultAddress,
  SHIPPING_ADDRESS_SUB_EVENT,
  ADD_NEW_SHIPPING_ADDRESS_ID,
  isValidAddressId,
} from './utils'
import pubSubInstance from '../../shared/utils/pubSub'

function ShippingList({
  defaultSelectId,
  shippingAddressList = [],
  delAddressItemById,
  setDefaultAddressItemById,
  ...rest
}) {
  const formRef = useRef()
  const [isShowComfirnModal, setIsShowConfirmModal] = useState(false)
  const [pendingId, setPendingId] = useState()
  const [selectId, setSelectId] = useState()

  const handleListItemChange = useCallback(e => {
    setSelectId(e.target.value)
  }, [])

  const onDeleteById = useCallback(id => {
    setIsShowConfirmModal(true)
    setPendingId(id)
  }, [])

  const onCancelDel = useCallback(() => {
    setIsShowConfirmModal(false)
  }, [])

  const onContinueDel = useCallback(() => {
    delAddressItemById(pendingId)
    setIsShowConfirmModal(false)
  }, [pendingId, delAddressItemById])

  const getFormValues = useCallback(() => ({
    status: 'SUCCESS',
    from: 'shipping-list',
    values: formRef.current?.values,
  }), [formRef.current])

  useEffect(() => {
    pubSubInstance.subscribe(SHIPPING_ADDRESS_SUB_EVENT.submit, getFormValues)
    return () => {
      pubSubInstance.unsubscribe(SHIPPING_ADDRESS_SUB_EVENT.submit, getFormValues)
    }
  }, [getFormValues])

  useEffect(() => {
    pubSubInstance.subscribe(SHIPPING_ADDRESS_SUB_EVENT.getAddress, getFormValues)
    return () => {
      pubSubInstance.unsubscribe(SHIPPING_ADDRESS_SUB_EVENT.getAddress, getFormValues)
    }
  }, [getFormValues])

  useEffect(() => {
    if (defaultSelectId && isValidAddressId(defaultSelectId, shippingAddressList)) {
      setSelectId(defaultSelectId)
    } else {
      const defaultAddress = find(shippingAddressList, isDefaultAddress)
      setSelectId(defaultAddress?.shippingAddressId || shippingAddressList[0]?.shippingAddressId)
    }
  }, [shippingAddressList, defaultSelectId])

  return !isEmpty(shippingAddressList) && (
  <>
    <Form
      customizeLayout
      initialValues={{
        addressListItem: selectId,
      }}
      enableReinitialize
    >
      <FormGroup name="addressListItem">
        <FormField
          onChange={handleListItemChange}
          as={RadioGroup}
        >
          {
                shippingAddressList.map(shippingAddress => {
                  const { shippingAddressId: itemId } = shippingAddress
                  return (
                    <ShippingListItem
                      id={itemId}
                      selectId={selectId}
                      shippingAddress={shippingAddress}
                      onDelete={() => onDeleteById(itemId)}
                      onSetDefault={() => setDefaultAddressItemById(itemId)}
                      {...rest}
                    />
                  )
                })
            }
          {shippingAddressList.length < 10 && (
          <ShippingListItem
            id={ADD_NEW_SHIPPING_ADDRESS_ID}
            selectId={selectId}
            {...rest}
          />
          )}
        </FormField>
      </FormGroup>
      <FormConsumer>
        {({ form }) => {
          formRef.current = form
        }}
      </FormConsumer>
    </Form>
    <ConfirmModal
      title={<Locale id="passport.shipping.address.confirm.delete.title" />}
      content={<span><Locale id="passport.shipping.address.confirm.delete.msg" /></span>}
      cancelText={<Locale id="passport.common.btn.no" />}
      okText={<Locale id="passport.common.btn.yes" />}
      handleOk={onContinueDel}
      handleCancel={onCancelDel}
      onClose={onCancelDel}
      shown={isShowComfirnModal}
    />
  </>
  )
}

export default ShippingList
